<div class="input-select timepicker-input">
    <mat-select [(ngModel)]="value" [disabled]="disabled">
        <mat-option></mat-option>
        <mat-option *ngFor="let time of times" [value]="time"
            >{{ time }}
        </mat-option>
    </mat-select>
</div>
